import React, { useState } from 'react';
import { Card, Label, BtnPrimary, RankBadge, SectionTitle, Avatar, StatBar } from './UI';
import { getRank, RANKS } from '../lib/claude';

const STYLES = [
  { id: 'torpe', label: 'Torpe', desc: 'Shy but secretly sharp — thinks twice before speaking but hits hard when it does.' },
  { id: 'epal', label: 'Epal', desc: 'Loud and always has something to say — the life of the party, like it or not.' },
  { id: 'diskarte', label: 'Diskarte', desc: 'Street-smart and adaptable — always finds a clever angle no matter the situation.' },
  { id: 'hugot', label: 'Hugot', desc: 'Deeply emotional — connects everything back to love, loss, and life lessons.' },
  { id: 'seryoso', label: 'Seryoso', desc: 'Logical and fact-driven — no drama, just cold hard truth.' }
];

export default function AlalayScreen({ botConfig, setBotConfig, stats }) {
  const [name, setName] = useState(botConfig.name);
  const [style, setStyle] = useState(botConfig.style);
  const [instrux, setInstrux] = useState(botConfig.instrux);
  const [saved, setSaved] = useState(false);

  const rank = getRank(stats.elo);
  const nextRank = RANKS[RANKS.indexOf(rank) + 1];
  const progress = nextRank
    ? Math.round(((stats.elo - rank.min) / (nextRank.min - rank.min)) * 100)
    : 100;

  function save() {
    setBotConfig({ name: name || 'Alalay Ko', style, instrux });
    setSaved(true);
    setTimeout(() => setSaved(false), 2000);
  }

  return (
    <div style={{ animation: 'slideUp 0.3s ease' }}>
      <Card>
        <div style={{ textAlign: 'center', paddingBottom: '0.75rem' }}>
          <div style={{
            fontSize: 52, marginBottom: 8,
            animation: 'floatBob 3s ease-in-out infinite'
          }}>⚡</div>
          <div style={{ fontFamily: 'var(--font-display)', fontSize: 20, fontWeight: 700 }}>
            {botConfig.name || 'No name yet, pre!'}
          </div>
          <div style={{ marginTop: 6 }}>
            <RankBadge elo={stats.elo} />
          </div>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 8, margin: '1rem 0' }}>
          {[
            { val: stats.wins, lbl: 'Wins' },
            { val: stats.losses, lbl: 'Losses' },
            { val: stats.battles, lbl: 'Battles' }
          ].map(({ val, lbl }) => (
            <div key={lbl} style={{
              background: 'rgba(255,255,255,0.04)', borderRadius: 10,
              padding: '10px 8px', textAlign: 'center'
            }}>
              <div style={{ fontFamily: 'var(--font-display)', fontSize: 22, fontWeight: 800 }}>{val}</div>
              <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 2 }}>{lbl}</div>
            </div>
          ))}
        </div>

        <StatBar value={stats.elo - rank.min} max={nextRank ? nextRank.min - rank.min : 100} color={rank.color} />
        <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 4 }}>
          {stats.elo} ELO · {nextRank ? `${nextRank.min - stats.elo} more to become ${nextRank.emoji} ${nextRank.name}` : '👑 Maximum rank na — grabe ka talaga!'}
        </div>
      </Card>

      <Card>
        <SectionTitle>Customize your Alalay</SectionTitle>

        <Label>Your Alalay's name</Label>
        <input
          value={name}
          onChange={e => setName(e.target.value)}
          placeholder="e.g. Dodong, Karen, Bebang..."
          style={{ marginBottom: 16 }}
        />

        <Label>Battle style</Label>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginBottom: 16 }}>
          {STYLES.map(st => (
            <button
              key={st.id}
              onClick={() => setStyle(st.desc)}
              style={{
                padding: '7px 14px',
                borderRadius: 20,
                fontSize: 13,
                fontWeight: 500,
                border: '1px solid',
                borderColor: style === st.desc ? 'var(--purple)' : 'var(--border)',
                background: style === st.desc ? 'rgba(108,59,255,0.2)' : 'transparent',
                color: style === st.desc ? 'var(--purple)' : 'var(--text-muted)',
                cursor: 'pointer',
                transition: 'all 0.15s'
              }}
            >
              {st.label}
            </button>
          ))}
        </div>

        <Label>Extra instructions for your Alalay (optional)</Label>
        <textarea
          rows={3}
          value={instrux}
          onChange={e => setInstrux(e.target.value)}
          placeholder="e.g. Always start with a proverb. Super proud of being Cebuano. Calls everyone 'pre'..."
        />

        <BtnPrimary onClick={save} style={saved ? { background: 'var(--teal)' } : {}}>
          {saved ? '✓ Alalay saved! Laban na!' : 'Save your Alalay →'}
        </BtnPrimary>
      </Card>
    </div>
  );
}
